"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@chakra-ui/react");
var _react2 = _interopRequireDefault(require("react"));
var _Table = _interopRequireDefault(require("./Table"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const prepareData = items => {
  return items.map(e => ({
    prefix: e.prefix,
    fileName: e.name,
    fileLastModifiedAt: e.modifiedAt,
    fileSize: e.fileSize || '-',
    isDropzone: e.isFolder
  }));
};
const columns = [{
  Header: 'Name',
  accessor: 'fileName',
  width: '80%',
  Cell: ({
    row
  }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.HStack, {
    children: [row.original.prefix, /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Text, {
      children: row.original.fileName
    })]
  })
}, {
  Header: 'Last modified',
  accessor: 'fileLastModifiedAt'
}, {
  Header: 'File size',
  accessor: 'fileSize',
  isNumeric: true,
  disableSortBy: true
}];
const initialState = {
  sortBy: [{
    id: 'fileLastModifiedAt',
    desc: true
  }]
};
const FileList = ({
  items,
  ...props
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.default, {
    columns: columns,
    records: prepareData(items),
    initialState: initialState,
    ...props
  });
};
var _default = /*#__PURE__*/_react2.default.memo(FileList);
exports.default = _default;